import { render, staticRenderFns } from "./UploadAgendaItems.vue?vue&type=template&id=17d58404&"
import script from "./UploadAgendaItems.vue?vue&type=script&lang=js&"
export * from "./UploadAgendaItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports